<ap-illustration name="klaar"></ap-illustration>
<h1>
    <ap-content key="logout-page.title"></ap-content>
</h1>
<p><ap-content key="logout-page.message"></ap-content></p>
<ap-button (onClick)="navigateToLogin()" [text]="true">
    <ap-content key="logout-page.login"></ap-content>
</ap-button>
